import { darken, lighten } from 'polished';

const theme = {
  carvana: {
    body: '#ffffff',
    blue: {
      new: '#0092D8',
      primary: '#00aed9',
      hover: '#018dc0',
      medium: '#00619e', // sticky header bg
      dark: '#183558', // headlines and footer
      pastel: '#cfeaf2', // accent
      dropdown: '#08689a'
    },
    black: {
      background: '#000'
    },
    gray: {
      background: '#f4f8fa',
      light: '#d9dde9', // secondary copy, tabs and field outlines, lines
      medium: '#aab1c7', // unselected Icons, favorites heart and other things
      dark: '#757989' // text and icons
    },
    green: {
      primary: '#1dd08b'
    }, // success green
    red: {
      primary: '#ff7171'
    }, // alert red, faved
    white: {
      primary: '#ffffff'
    },
    yellow: {
      primary: '#feb948',
      hover: '#eb9f23',
      pastel: '#fbf2de'
    },
    stroke: {
      blue: '#122946' // divider line color in footer
    },
    impersonationRed: '#ff0000'
  },
  campaigns: {
    barrett: {
      red: '#E0544B',
      darkRed: darken(0.1, '#E0544B'),
      lightRed: lighten(0.05, '#E0544B'),
      darkerRed: darken(0.2, '#E0544B'),
      lighterRed: lighten(0.1, '#E0544B'),

      yellow: '#FEB948',
      darkYellow: darken(0.1, '#FEB948'),
      lightYellow: lighten(0.1, '#FEB948'),
      darkerYellow: darken(0.2, '#FEB948'),
      lighterYellow: lighten(0.2, '#FEB948'),

      purple: '#63508C',
      darkPurple: darken(0.1, '#63508C'),
      lightPurple: lighten(0.1, '#63508C'),
      darkerPurple: darken(0.2, '#63508C'),
      lighterPurple: lighten(0.2, '#63508C'),

      orange: '#B75535',
      darkerOrange: darken(0.2, '#B75535'),
      lighterOrange: lighten(0.2, '#B75535'),

      grey: '#414144',
      darkGrey: darken(0.05, '#414144'),
      lightGrey: lighten(0.05, '#414144'),
      darkerGrey: darken(0.1, '#414144'),
      lighterGrey: lighten(0.2, '#414144'),

      slate: '#DCDFE5',
      darkSlate: darken(0.05, '#ABB1C5'),
      lightSlate: lighten(0.15, '#ABB1C5'),
      darkerSlate: darken(0.2, '#ABB1C5'),
      lighterSlate: lighten(0.4, '#ABB1C5')
    },
    jj: {
      blue: {
        dark: '#0D375E',
        // medium: '#1971C2',
        medium: '#106BC7',
        primary: '#228BE6'
      },
      gray: {
        neutral2: '#D9DDE9',
        neutral3: '#AAB1C7'
      },
      yellow: {
        dark: '#FAB005',
        primary: '#FFD43B'
      }
    },
    shared: {
      gray: {
        primary: '#696969',
        inputBorder: '#ccc'
      },
      red: {
        error: '#c20000'
      }
    },
    faq: {
      searchField: {
        boxShadow: '0 3px 4px 0 rgba(202, 202, 202, 0.5)'
      },
      faqItem: {
        dividerColor: '#ccc'
      }
    },
    contactUs: {
      gray: {
        secondary: '#666'
      }
    },
    tooltip: {
      dark: '#434343',
      light: '#ffffff'
    },
    feature: '#0094ca',
    slideshow: {
      activeTab: '#fdb84a',
      breakpoint: 1080,
      overlay: '#000'
    }
  },
  typography: {
    fontFamilyLight:
      '"Brandon Text Light", "Brandon Text Regular", "Lato", sans-serif',
    fontFamilyLightItalic:
      '"Brandon Text Light Italic", "Brandon Text Regular", "Lato", sans-serif',
    fontFamily: '"Brandon Text", "Lato", sans-serif',
    fontFamilyItalic:
      '"Brandon Text Italic", "Brandon Text Regular", "Lato", sans-serif',
    fontFamilyBold: '"Brandon Text", "Brandon Text", "Lato", sans-serif',
    fontFamilyBoldItalic:
      '"Brandon Text Bold Italic", "Brandon Text Regular", "Lato", sans-serif',
    fontSize: 16
  },
  breakpoints: {
    values: {
      ss: 375,
      xs: 414,
      sm: 768,
      md: 1024,
      lg: 1280,
      lgxl: 1440,
      xl: 1800
    },
    heights: {
      xs: 414,
      sm: 768,
      md: 1024,
      lg: 1280,
      lgxl: 1440,
      xl: 1800
    }
  }
};

export default theme;
